module.exports = __webpack_public_path__ + "std/img/red-packet-start.53e8832.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/red-packet-start.webp
// module id = DNqe
// module chunks = 0 10